module.exports = __webpack_public_path__ + "static/media/Profile-1-ss-art-1.716960b7.png";